import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We provide a helper package that will hook into the Next.js build process and upload source maps for your client and server code. This process is enabled by default for production builds but you can disable it by setting `}<inlineCode parentName="p">{`enabled`}</inlineCode>{` to `}<inlineCode parentName="p">{`false`}</inlineCode>{` in the `}<inlineCode parentName="p">{`sourcemaps`}</inlineCode>{` object.`}</p>
    <h4 {...{
      "id": "1-install-package"
    }}>{`1. Install package`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install @posthog/nextjs-config
`}</code></pre>
    <h4 {...{
      "id": "2-update-your-next-config"
    }}>{`2. Update your next config`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "file=next.config.js",
        "file": "next.config.js"
      }}>{`
import { withPostHogConfig } from "@posthog/nextjs-config";

const nextConfig = {
  //...your nextjs config,
};

export default withPostHogConfig(nextConfig, {
  personalApiKey: process.env.POSTHOG_API_KEY, // Personal API Key
  envId: process.env.POSTHOG_ENV_ID, // Environment ID
  host: process.env.NEXT_PUBLIC_POSTHOG_HOST, // (optional), defaults to https://us.posthog.com
  sourcemaps: { // (optional)
      enabled: true, // (optional) Enable sourcemaps generation and upload, default to true on production builds
      project: "my-application", // (optional) Project name, defaults to repository name
      version: "1.0.0", // (optional) Release version, defaults to current git commit
      deleteAfterUpload: true, // (optional) Delete sourcemaps after upload, defaults to true
  },
});

`}</code></pre>
    <p>{`Where you should set the following environment variables:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Environment Variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`POSTHOG_API_KEY`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://app.posthog.com/settings/user-api-keys#variables"
            }}>{`Personal API key`}</a>{` with at least `}<inlineCode parentName="td">{`write`}</inlineCode>{` access on `}<inlineCode parentName="td">{`error tracking`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`POSTHOG_ENV_ID`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Project ID you can find in your `}<a parentName="td" {...{
              "href": "https://app.posthog.com/settings/environment#variables"
            }}>{`project settings`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`NEXT_PUBLIC_POSTHOG_HOST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Your PostHog instance URL. Defaults to `}<inlineCode parentName="td">{`https://us.posthog.com`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "thats-it"
    }}>{`That's it!`}</h3>
    <p>{`Now when you build your application with `}<inlineCode parentName="p">{`next build`}</inlineCode>{`, your sourcemaps are uploaded to PostHog and you will be able to see the unminified code your error originated from in your dashboard. This step is disabled by default with `}<inlineCode parentName="p">{`next dev`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      